// extracted by mini-css-extract-plugin
export default {"page":"StatsDetail_page__7tb7L","errorCard":"StatsDetail_errorCard__GjT8W"};